import React from "react";
import { FiX } from "react-icons/fi";
import { User } from "../../../types";
import utils from "../../../helpers/utils";

interface StudentManagementModalHeaderProps {
  student: User;
  onClose: () => void;
}

export default function StudentManagementModalHeader({
  student,
  onClose,
}: StudentManagementModalHeaderProps) {
  return (
    <div className="relative border-b border-stroke bg-gradient-to-r from-purple-50 via-purple-50 to-purple-50 px-3 py-3 sm:px-4 sm:py-4 md:px-6 dark:border-strokedark dark:from-purple-950/30 dark:via-purple-950/30 dark:to-purple-950/30">
      {/* Decorative Background Pattern */}
      <div className="absolute inset-0 bg-grid-pattern opacity-5" />

      {/* Botão fechar - Mobile First (min 44px touch target) */}
      <div className="absolute right-2 top-2 sm:right-3 sm:top-3 md:right-6 md:top-6 z-10 flex items-center gap-1 sm:gap-1.5 md:gap-2">
        <button
          onClick={onClose}
          className="flex items-center justify-center rounded-xl min-w-[44px] min-h-[44px] p-2 sm:min-w-0 sm:min-h-0 sm:p-2 text-gray-500 outline-none transition-all active:bg-white active:text-gray-700 active:scale-95 md:hover:bg-white md:hover:text-gray-700 md:hover:shadow-sm focus-visible:ring-2 focus-visible:ring-primary dark:text-gray-400 dark:active:bg-boxdark dark:active:text-gray-200 md:dark:hover:bg-boxdark md:dark:hover:text-gray-200 touch-manipulation"
          aria-label="Fechar modal"
        >
          <FiX size={20} className="sm:w-[22px] sm:h-[22px]" />
        </button>
      </div>

      {/* Informações do Aluno - Mobile First */}
      <div className="relative flex items-start gap-2 sm:gap-3 pr-14 sm:pr-16 md:pr-24">
        {/* Avatar com Ring - Mobile First */}
        <div className="relative flex-shrink-0">
          <div className="absolute -inset-0.5 sm:-inset-1 rounded-full bg-gradient-to-r from-purple-600 to-purple-600 opacity-75 blur-sm" />
          <div className="relative h-14 w-14 sm:h-16 sm:w-16 overflow-hidden rounded-full border-2 sm:border-3 border-white shadow-xs dark:border-boxdark">
            <img
              src={
                student.photo ||
                `https://ui-avatars.com/api/?name=${encodeURIComponent(
                  student.name,
                )}&background=85368c&color=fff&size=200`
              }
              alt={student.name}
              className="h-full w-full object-cover"
            />
          </div>
          <div className="absolute -bottom-0.5 -right-0.5 rounded-full bg-green-500 p-1 sm:p-1.5 shadow-sm border-2 border-white dark:border-boxdark">
            <div className="h-1.5 w-1.5 sm:h-2 sm:w-2 rounded-full bg-white" />
          </div>
        </div>

        <div className="flex-1 min-w-0 pt-0.5 sm:pt-1">
          <div className="flex flex-col gap-1 sm:gap-2">
            <h3 className="text-lg sm:text-xl md:text-2xl font-bold text-gray-900 dark:text-white truncate leading-tight">
              {student.name}
            </h3>
            <div className="flex flex-wrap items-center gap-1.5 sm:gap-2">
              <span className="inline-flex rounded-full bg-purple-100 px-2 sm:px-2.5 py-0.5 sm:py-1 text-[10px] sm:text-xs font-semibold text-purple-700 dark:bg-purple-900/30 dark:text-purple-300">
                {utils.calcularIdade(
                  new Date(student.birth_date || new Date()),
                )}{" "}
                anos
              </span>
            </div>
          </div>
          <p className="mt-1 sm:mt-1.5 text-xs sm:text-sm text-gray-600 dark:text-gray-400 truncate">
            {student.email}
          </p>
        </div>
      </div>
    </div>
  );
}
